import { extendedCardFromSerial } from "../serials/tags/extendedCards";
import { DEFAULT_PLATES } from "../serials/tags/artPlates";

// Texto de exemplo das placas na revisão (spec 2026-10-01 §6): condição NM e um número no
// formato do serial estendido (<prefixo E><inicial><8 dígitos>).
export const SAMPLE_CONDITION = "NM";
export const SAMPLE_SERIAL = "EP00000000";

/** Modelo de exemplo quando a arte ainda não atende nenhum modelo. */
export const sampleModel = (art) => ({
    name: art?.cardName || "",
    edition: art?.setName || art?.setId || "",
    language: "Portuguese",
});

export const modelOptionLabel = (model) => [model?.name, model?.edition, model?.language].filter(Boolean).join(" · ");

/**
 * Cartão do papel "art" para a pré-visualização: mesmo texto que o gerador tiraria do modelo
 * (extendedCardFromSerial), com a variação em revisão no lugar da arte aprovada. Placas no tom
 * padrão: o contraste automático por luminância é do gerador.
 */
export function previewCard({ model, art, artUrl, cardImageUrl }) {
    const base = extendedCardFromSerial({
        gradableModel: model || sampleModel(art),
        serialNumber: SAMPLE_SERIAL,
        condition: SAMPLE_CONDITION,
        notaAutografo: null,
    });
    return {
        ...base,
        visual: "art_extended",
        art: { url: artUrl || null, sourceUrl: cardImageUrl || null, plates: { ...DEFAULT_PLATES } },
    };
}
